module.exports = __webpack_public_path__ + "img/00014.36a35088.webp";